/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ shown: NonNullable<unknown>, total: NonNullable<unknown> }} Spaces_Spreadsheet_Rows_OfInputs */



/**
* | output |
* | --- |
* | "{shown} of {total} rows" |
*
* @param {Spaces_Spreadsheet_Rows_OfInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_spreadsheet_rows_of = /** @type {((inputs: Spaces_Spreadsheet_Rows_OfInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Spreadsheet_Rows_OfInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.shown} von ${i?.total} Zeilen`)
	return /** @type {LocalizedString} */ (`${i?.shown} of ${i?.total} rows`)
});